import { Socket, io } from "socket.io-client";
import {
  ClientToServerEvents,
  ServerToClientEvents
} from "@rinastyling/common";

export type ClientSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

export class SocketIoService {
  private static socket: ClientSocket;

  static get instance() {
    if (!this.socket) {
      this.socket = io(process.env.NEXT_PUBLIC_BASE_URL, {
        autoConnect: false,
        path: "/api/socket.io"
      });

      console.log("create a new socket instance ");
    }

    return this.socket;
  }
}
